import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    policyList: null,
    isLoading: false,
    isLoadingButton: false,
    policySearchTrigger: false,
  },
  actions,
  getters,
  mutations,
};
